import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import AreaType from '@blade-sxp/task-management/components/area-type/index.vue';
import VirtualArea from '@blade-sxp/task-management/components/virtual-area/index.vue';
import InitialVisitorNumber from '@blade-sxp/task-management/components/initial-visitor-number.vue';
import ThermalIntervalValue from '@blade-sxp/task-management/components/thermal-nterval-value.vue';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep, isEqual } from 'lodash';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import { directionSet } from '@blade-sxp/task-management/utils/direction-set';
import { FictitiousMapModule } from '@blade-sxp/task-management/store/fictitiousMap';
import { ZoneTypeModule } from '@blade-sxp/task-management/store/zoneType';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
// import VisitorsPortrait from '@blade-sxp/task-management/components/visitors-portrait.vue';
import VisitorsPortrait from '@blade-sxp/task-management/components/visitors-portrait/index.vue';
import EntranceExit from '@blade-sxp/task-management/components/entrance-exit/index.vue';
import { initEntranceExitDataConfig, initProtraitRecognitionConfig, initProtraitOutputConfig, initProtraitOutputRadiosConfig, } from '@blade-sxp/task-management/config/createTaskConfig';
import { AccountModule } from '@blade-sxp/account/store/account';
import TaskSkeleton from '@blade-sxp/task-management/components/task-skeleton.vue';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let CrowdCountingVa = class CrowdCountingVa extends Vue {
    virtualLevelConfigType = 'NEARLY_TEN_MINUTES'; // REAL_TIME （实时人数）,NEARLY_TEN_MINUTES（近十分钟）
    isTotalArea = false; // 是否是总区域
    loading = false;
    name = '';
    status = 'ENABLE';
    isDetail = false;
    type = 'add';
    disableRight = false;
    id = '';
    taskType = '';
    isReady = false;
    isError = false;
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    faceStatus = 'DISABLE';
    bodyStatus = false;
    critical = null;
    major = null;
    minor = null;
    time = null;
    tagId = '';
    regionId = '';
    faceDeviceIdListData = [];
    bodyDeviceIdListData = [];
    remark = '';
    selectedDevices = [];
    entranceExitData = initEntranceExitDataConfig();
    protraitSwitchVal = false;
    protraitRecognitionConfig = initProtraitRecognitionConfig();
    protraitOutputConfig = initProtraitOutputConfig();
    protraitOutputRadiosConfig = initProtraitOutputRadiosConfig();
    get isSelectedDevicesData() {
        return this.selectedDevices.length > 0;
    }
    get computedDisableRight() {
        const isEntranceExit = this.validEntranceExit();
        return this.disableRight || !isEntranceExit;
    }
    get userInfo() {
        return AccountModule.accountInfo;
    }
    get is3DUE() {
        const { mapType } = this.userInfo || {};
        return mapType === '3D_UE';
    }
    get vaMapVertices() {
        return this.is3DUE ? FictitiousMapModule.UEHotMapData : FictitiousMapModule.paintData;
    }
    get zoneTypeData() {
        return ZoneTypeModule.zoneTypeData;
    }
    get isParentId() {
        return FictitiousMapModule.isParentId;
    }
    get formData() {
        const { vaMapVertices, regionId, faceDeviceIdListData, name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady, tagId, time, critical, major, minor, faceStatus, bodyStatus, bodyDeviceIdListData, protraitSwitchVal, protraitRecognitionConfig, entranceExitData, } = this;
        return {
            vaMapVertices,
            regionId,
            faceDeviceIdListData,
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
            tagId,
            time,
            critical,
            major,
            minor,
            faceStatus,
            bodyStatus,
            bodyDeviceIdListData,
            protraitSwitchVal,
            protraitRecognitionConfig,
            entranceExitData,
        };
    }
    bodyStatusChange(val) {
        if (!val) {
            this.bodyDeviceIdListData = [];
        }
    }
    faceStatusChange(val) {
        if (val === 'DISABLE') {
            this.faceDeviceIdListData = [];
            this.bodyDeviceIdListData = [];
            this.bodyStatus = false;
        }
    }
    async validForm(val, oldVal) {
        if (this.isDetail) {
            return;
        }
        if (this.faceStatus === 'ENABLE') {
            if (isEmpty(this.faceDeviceIdListData)) {
                this.disableRight = true;
                return;
            }
        }
        if (this.bodyStatus) {
            if (isEmpty(this.bodyDeviceIdListData)) {
                this.disableRight = true;
                return;
            }
        }
        if (!this.regionId) {
            this.disableRight = true;
            return;
        }
        if (!this.isParentId) {
            if (isEmpty(this.vaMapVertices)) {
                this.disableRight = true;
                return;
            }
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        if (this.protraitSwitchVal) {
            const recognitionProps = this.protraitRecognitionConfig.props;
            let isDisable = false;
            let hasChecked = false;
            for (let k in recognitionProps) {
                const { isChecked = false, selectList = [] } = recognitionProps[k];
                if (isChecked) {
                    hasChecked = true;
                    selectList?.length === 0 && (isDisable = true);
                }
            }
            // 一个都未勾选或者勾选了未选择设备都不允许提交
            if (!hasChecked || isDisable) {
                this.disableRight = true;
                return;
            }
        }
        for (let i = 1; i <= 5; i++) {
            if (this.$refs['ruleForm' + i]) {
                let res = await this.$refs['ruleForm' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
        if (!isEqual(val.tagId, oldVal.tagId)) {
            this.entranceExitData = initEntranceExitDataConfig();
        }
    }
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    getData() {
        this.loading = true;
        Service.getTaskDetail(Number(this.id))
            .then(({ roiData, name, status, remark, bizTaskConfig, alarmConfig: { thresholdConfigs }, deviceTaskConfigs, virtualZoneInfo, tagInfo, }) => {
            this.dealBizTaskConfigData(bizTaskConfig);
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            this.tagId = tagInfo?.id;
            this.regionId = virtualZoneInfo?.id;
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes, initCountValue, levelConfig, virtualLevelConfigType } = thresholdConfigs[0];
                this.time = initCountValue?.value;
                this.critical = levelConfig?.critical;
                this.minor = levelConfig?.minor;
                this.major = levelConfig?.major;
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                this.virtualLevelConfigType = virtualLevelConfigType || this.getDefaultVirtualLevelConfigType(); // 分区域需要回显是最近10分钟还是实时, 默认10分钟
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
            }
            if (!isEmpty(deviceTaskConfigs)) {
                const selectedDevices = []; // 勾选的设备
                deviceTaskConfigs.forEach((item) => {
                    const roiData = item.roiData;
                    const modelType = item?.crosslineStatisticConfig?.modelSelection;
                    if (item.incidentType === 'INCIDENT_CROSS_LINE' && !isEmpty(roiData)) {
                        let analysis = JSON.parse(roiData);
                        if (modelType && analysis && analysis.titleList && analysis.titleList.length > 0) {
                            analysis.titleList.forEach((item) => {
                                if (item.type === 'MODEL') {
                                    item.data = modelType;
                                }
                            });
                        }
                        DeviceIdDataModule.deviceIdRequestParams.set(String(analysis.id), analysis);
                    }
                    selectedDevices.push({
                        ...item,
                        id: item.deviceId,
                        name: item.deviceName,
                    });
                });
                this.selectedDevices = selectedDevices; // 勾选设备回显
            }
            const vaData = JSON.parse(roiData);
            if (this.is3DUE) {
                FictitiousMapModule.updataUEHotMapData(vaData?.vaData);
            }
            else {
                FictitiousMapModule.updataPaintData(vaData?.vaData);
            }
        })
            .finally(() => {
            setTimeout(() => {
                this.loading = false;
            }, 500);
        });
    }
    dealBizTaskConfigData(bizTaskConfig) {
        const virtualTaskConfig = bizTaskConfig?.virtualTaskConfig;
        if (!virtualTaskConfig)
            return;
        const { virtualPlaceConfig } = virtualTaskConfig;
        this.dealEntranceEixt(virtualPlaceConfig);
        this.dealVirtualConfig(virtualTaskConfig);
    }
    // 处理访客画像数据
    dealVirtualConfig(virtualTaskConfig) {
        const { faceAttributeType, faceDeviceIds, facePedestrianDeviceIds, pedestrianAttributeType } = virtualTaskConfig;
        if ((pedestrianAttributeType ?? [])?.length === 0 && (faceAttributeType ?? [])?.length === 0)
            return;
        this.protraitSwitchVal = true;
        // 属性识别
        const { face, body } = this.protraitRecognitionConfig.props;
        face.isChecked = (faceDeviceIds ?? [])?.length > 0;
        face.selectList = faceDeviceIds ?? [];
        body.isChecked = (facePedestrianDeviceIds ?? [])?.length > 0;
        body.selectList = facePedestrianDeviceIds ?? [];
        // 属性输出
        const { age, gender } = this.protraitOutputConfig.props;
        // const { ageVal, genderVal } = this.getAgeGenderVal(faceAttributeType, pedestrianAttributeType);
        age.val = faceAttributeType.find((item) => item === 'AGE')
            ? 'face'
            : pedestrianAttributeType.find((item) => item === 'AGE')
                ? 'body'
                : '';
        gender.val = faceAttributeType.find((item) => item === 'SEX')
            ? 'face'
            : pedestrianAttributeType.find((item) => item === 'SEX')
                ? 'body'
                : '';
        // 年龄和性别的属性输出 是否可用
        this.protraitOutputRadiosConfig.forEach((item) => {
            const key = item.key;
            let isAble = false;
            switch (key) {
                case 'face':
                    isAble = face.isChecked; // (faceAttributeType ?? []).length > 0;
                    break;
                case 'body':
                    isAble = body.isChecked; // (pedestrianAttributeType ?? []).length > 0;
                    break;
            }
            item.disabled = !isAble;
        });
    }
    // 处理进出口数据
    dealEntranceEixt(virtualPlaceConfig) {
        const { entrance, exit } = this.entranceExitData;
        const entrancesList = this.dealEntranceEixtDataFormat(virtualPlaceConfig?.entrances ?? [], 'entrance');
        const exitsList = this.dealEntranceEixtDataFormat(virtualPlaceConfig?.exits ?? [], 'exit');
        entrance && (entrance.list = entrancesList);
        exit && (exit.list = exitsList);
    }
    // 处理进出口数据格式
    dealEntranceEixtDataFormat(list, dataType) {
        const arr = [];
        (list ?? [])?.forEach((item) => {
            const { roiData = null } = JSON.parse(item.roiData ?? '{}');
            let position = null;
            if (this.is3DUE) {
                position = roiData ? [...roiData] : null;
            }
            else {
                position = roiData ? { ...roiData } : null;
            }
            arr.push({
                dataType,
                name: item?.virtualTaskName ?? '',
                list: item?.deviceIds ?? [],
                position: position,
                id: item?.virtualTaskId,
                virtualTaskId: item?.virtualTaskId,
            });
        });
        return arr;
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const entranceExitData = this.getExitEntranceData();
        const faceBodyType = this.getFaceBodyType();
        const faceBodyDeviceIds = this.getFaceBodyDeviceIds();
        const roiData = {
            vaData: this.vaMapVertices,
        };
        const params = {
            remark: this.remark,
            taskName: this.name,
            taskStatus: taskStatus,
            taskType: this.taskType,
            tagId: this.tagId,
            zoneId: this.regionId,
            alarmConfig: {
                enable: true,
                thresholdConfigs: [
                    {
                        virtualLevelConfigType: this.virtualLevelConfigType,
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : [...effectiveTimes],
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                        initCountValue: {
                            countUnitEnum: 'PERCENT',
                            value: this.time,
                        },
                        levelConfig: {
                            critical: this.critical,
                            major: this.major,
                            minor: this.minor,
                            unit: 'PERCENT',
                        },
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
            roiData: JSON.stringify(roiData),
            bizTaskConfig: {
                virtualTaskConfig: {
                    // faceDeviceIds: this.faceDeviceIdListData,
                    // facePedestrianDeviceIds: this.bodyDeviceIdListData,
                    ...faceBodyDeviceIds,
                    ...faceBodyType,
                    // 进出口以及位置设置
                    virtualPlaceConfig: {
                        // entrances: entrancesData,
                        // exits: extitData,
                        ...entranceExitData,
                    },
                },
            },
        };
        if (this.type === 'add' || this.type === 'copy') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    fromDataDeviceConfig() {
        let config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                let persons = [];
                let rawRoi = {};
                let crosslineStatisticConfig = {};
                let modelSelectionObj = {};
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'BODY') {
                            item.data.forEach((item) => {
                                let pern = {
                                    x: item.vertices[0].y > item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                    y: item.vertices[0].y < item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                };
                                persons.push(pern);
                            });
                        }
                        if (item.type === 'LINES') {
                            item.data.forEach((item) => {
                                crosslineStatisticConfig = {
                                    crossLine: item.vertices,
                                    directions: directionSet(item.direction),
                                    roiId: this.taskId(),
                                };
                            });
                        }
                        if (item.type === 'MODEL') {
                            modelSelectionObj.modelSelection = item.data;
                        }
                    });
                    rawRoi = { ...modelSelectionObj, ...crosslineStatisticConfig };
                }
                let data = {
                    crosslineStatisticConfig: rawRoi,
                    labelPersons: persons,
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                };
                config.push(data);
            });
        }
        return config;
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    // 已选中设备
    handleSelectedDevices(devices) {
        this.selectedDevices = devices;
    }
    // 切换区域
    changeArea({ isTotalArea }) {
        const tempIsTotalArea = this.isTotalArea;
        this.isTotalArea = isTotalArea;
        if (tempIsTotalArea !== isTotalArea) {
            this.virtualLevelConfigType = this.getDefaultVirtualLevelConfigType();
        }
    }
    getDefaultVirtualLevelConfigType() {
        return 'NEARLY_TEN_MINUTES';
    }
    // getDataByType(type: string) {
    //   let data: any = null;
    //   switch (type) {
    //     case 'exit':
    //       data = this.getExitEntranceData(type);
    //       break;
    //     case 'entrance':
    //       data = this.getExitEntranceData(type);
    //       break;
    //   }
    //   return data;
    // }
    getExitEntranceData() {
        if (!this.isTotalArea)
            return {};
        const obj = {
            exits: [],
            entrances: [],
        };
        const entranceExitData = this.entranceExitData;
        for (let k in entranceExitData) {
            const val = entranceExitData[k];
            const dataBox = k === 'entrance' ? obj.entrances : obj.exits;
            const list = val.list;
            const virtualPlaceType = k === 'entrance' ? 'ENTRANCE' : 'EXIT';
            list?.forEach((item) => {
                if (item?.list?.length > 0 && item?.name) {
                    const tempObj = {
                        deviceIds: item?.list ?? [],
                        roiData: JSON.stringify({ roiData: item?.position }),
                        virtualPlaceType: virtualPlaceType,
                        virtualTaskId: item?.virtualTaskId ?? '',
                        virtualTaskName: item?.name ?? '',
                    };
                    dataBox.push(tempObj);
                }
            });
        }
        return obj;
    }
    // 获取人脸人体的类型 AGE/SEX
    getFaceBodyType() {
        const data = this.protraitOutputConfig.props;
        const faceAttrs = [];
        const bodyAttrs = [];
        if (this.protraitSwitchVal) {
            for (let k in data) {
                const dataItem = data[k];
                const val = dataItem.val;
                const attrType = k === 'age' ? 'AGE' : 'SEX';
                if (val === 'face') {
                    faceAttrs.push(attrType);
                }
                else if (val === 'body') {
                    bodyAttrs.push(attrType);
                }
                else {
                }
            }
        }
        return {
            faceAttributeType: faceAttrs,
            pedestrianAttributeType: bodyAttrs, // 人体属性
        };
    }
    // 获取人脸人体识别的相机
    getFaceBodyDeviceIds() {
        const data = this.protraitRecognitionConfig?.props;
        const faceDeviceIds = data?.face.isChecked ? data?.face?.selectList ?? [] : [];
        const bodyDevices = data?.body?.isChecked ? data?.body?.selectList ?? [] : [];
        const isAllowed = this.protraitSwitchVal;
        return {
            faceDeviceIds: isAllowed ? faceDeviceIds : [],
            facePedestrianDeviceIds: isAllowed ? bodyDevices : [],
        };
    }
    validEntranceExit() {
        if (!this.isTotalArea)
            return true;
        const data = this.entranceExitData;
        let isNull = false;
        for (let k in data) {
            const val = data[k];
            const emptyData = val?.list?.find((item) => item?.list?.length === 0 || !item?.name);
            isNull = !!emptyData;
            if (isNull)
                break;
        }
        return !isNull;
    }
};
__decorate([
    Watch('bodyStatus')
], CrowdCountingVa.prototype, "bodyStatusChange", null);
__decorate([
    Watch('faceStatus')
], CrowdCountingVa.prototype, "faceStatusChange", null);
__decorate([
    Watch('formData', { deep: true, immediate: true })
], CrowdCountingVa.prototype, "validForm", null);
__decorate([
    Watch('$route', { immediate: true, deep: true })
], CrowdCountingVa.prototype, "init", null);
CrowdCountingVa = __decorate([
    Component({
        name: 'CrowdCountingVa',
        components: {
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'button-box': ButtonBox,
            'st-device-darwer': DeviceDarwer,
            'st-area-type': AreaType,
            'st-area-virtual': VirtualArea,
            'st-initial-visitor-number': InitialVisitorNumber,
            'st-thermal-interval-value': ThermalIntervalValue,
            'task-note': TaskNote,
            'visitors-portrait': VisitorsPortrait,
            EntranceExit,
            'task-skeleton': TaskSkeleton,
        },
        i18n: {
            messages: {
                en: {
                    cancelSubmitTip: 'Data will not be saved and exited， Are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Ok',
                    cancel: 'Cancel',
                    visitorTitle: 'Initial Visitor Number',
                },
                zh: {
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                    visitorTitle: '初始人数',
                },
            },
        },
    })
], CrowdCountingVa);
export default CrowdCountingVa;
